import {
    type FC
} from "react";
import {
    Animated,
    View
} from "react-native";
import type ICollapseRegionProps from "./type";
import {
    useStyles
} from "./stylesheet";
import useCollapse from "./useCollapse";

const CollapseRegion: FC<ICollapseRegionProps> = ({
    isKeepMounted = false,
    contentStyle,
    customTheme,
    children,
    isOpen,
    style,
    ...props
}) => {
    const {
        isRendered,
        onLayout,
        opacity,
        height,
        phase
    } = useCollapse({
        isKeepMounted,
        customTheme,
        isOpen
    });

    const {
        region: regionDynamicStyle
    } = useStyles({
        opacity,
        height,
        phase
    });

    if(!isRendered) {
        return null;
    }

    return <Animated.View
        {...props}
        style={[
            style,
            regionDynamicStyle
        ]}
    >
        <View
            style={contentStyle}
            onLayout={onLayout}
        >
            {children}
        </View>
    </Animated.View>;
};
export default CollapseRegion;
